import React from "react";
import { Layout as AntLayout } from "antd";
import { Header } from "./Header";
import Footer from "./Footer";
// ContactUs 旧弹窗不再全局挂载，改为 Header 内全屏 NewContactUs

const { Content } = AntLayout;

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  // const {
  //   token: { colorBgContainer, borderRadiusLG },
  // } = theme.useToken()

  return (
    <AntLayout className="min-h-screen pt-16">
      <AntLayout>
        <Header />
        <Content style={{ margin: 0, padding: 0 }}>{children}</Content>
        {/* 全局 ContactUs 已迁移为 Header 内部的全屏 NewContactUs 触发 */}
        <Footer />
      </AntLayout>
    </AntLayout>
  );
};

export default Layout;
